import React, { useState } from 'react';
import CustomInput from '../../components/form/CustomInput';
import { useNavigate } from 'react-router-dom';
import CustomButtonConfirm from '../../components/form/CustomButtonConfirm';
import { loginSuccess } from '../../store/auth/login/action';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from 'react-redux';
import { postLoginToken, resetPassword } from '../../helpers/configRoutes/backend_helper';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [forgotPassword, setForgotPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const validation = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email("Correo electrónico no válido")
                .required("Ingresa tu correo electrónico"),
            password: Yup.string().when([], {
                is: () => !forgotPassword,
                then: schema => schema.required("Ingresa tu contraseña"),
            }),
        }),
        onSubmit: async (values, { setErrors }) => {
            setLoading(true);

            if (forgotPassword) {
                const response = await resetPassword(values);
                if (response.status === true) {
                    setForgotPassword(false);
                }
            } else {
                const response = await postLoginToken(values);
                if (response.status === true) {
                    dispatch(loginSuccess(response));
                    navigate(response.user.models[0].link);
                } else if (response.errors?.length) {
                    setErrors(response.errors);
                }
            }

            setLoading(false);
        },
    });

    return (
        <div className="min-h-screen flex items-center justify-center bg-cs-bg">
            <div className="w-full max-w-md bg-cs-surface border border-cs-border rounded-xl shadow-sm overflow-hidden">

                {/* Brand / Logo */}
                <div className="flex flex-col items-center justify-center bg-cs-primary-soft border-b border-cs-border py-1 px-6">
                    {/* LOGO */}
                    <img
                        src="/images/logoA.png"   // <-- ajusta la ruta
                        alt="Company Logo"
                        className="h-auto w-full"
                    />
                </div>

                {/* Form */}
                <div className="p-6">
                    <form
                        className="space-y-5"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                        }}
                    >
                        {forgotPassword && (
                            <div className="text-center text-sm text-cs-muted">
                                Ingresa el correo asociado a tu cuenta
                            </div>
                        )}

                        <CustomInput
                            label="Correo electrónico"
                            type="email"
                            name="email"
                            error={validation.errors.email}
                            value={validation.values.email}
                            handleChange={validation.handleChange}
                        />

                        {!forgotPassword && (
                            <CustomInput
                                label="Contraseña"
                                type="password"
                                name="password"
                                error={validation.errors.password}
                                value={validation.values.password}
                                handleChange={validation.handleChange}
                            />
                        )}

                        <CustomButtonConfirm
                            loading={loading}
                            textLoad="Procesando"
                            type="success"
                            className="w-full"
                            text={forgotPassword ? 'Enviar enlace' : 'Ingresar'}
                        />

                        {/* Actions */}
                        <div className="text-center text-sm">
                            <button
                                type="button"
                                className="text-cs-primary hover:underline"
                                onClick={() => setForgotPassword(!forgotPassword)}
                            >
                                {forgotPassword
                                    ? 'Volver al inicio de sesión'
                                    : '¿Olvidaste tu contraseña?'}
                            </button>
                        </div>
                    </form>
                </div>

                {/* Footer */}
                <div className="bg-cs-bg-alt border-t border-cs-border px-6 py-3 text-center text-xs text-cs-muted">
                    Acceso restringido · Uso interno
                </div>
            </div>
        </div>
    );

};

export default Login;
